// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"bdmpopup_gridContainer__EY7bg","bubble":"bdmpopup_bubble___AfMl"};